import { DeleteOutlineRounded } from "@mui/icons-material";
import { Box } from "@mui/system";

import { IconButton } from "@mui/material";

import { faPlay } from "@fortawesome/pro-solid-svg-icons";

import { IStageContentInfo } from "@/pages/Private/pages/Courses/constants/emptyCourseScenario";
import { FileTypes } from "@/pages/Private/pages/Courses/enums/FileTypes.enum";

import { Icon } from "../Icon/Icon";

interface VideoContainerProps {
	videoUrl: string | null;
	/**
	 * A WebVTT caption track, where the video has one.
	 *
	 * The intro-video export writes a sidecar alongside the burnt-in subtitles; the burn-in
	 * is what the author designed, and this is what a screen reader and a viewer who turns
	 * captions on get. `default` is deliberately not set — two copies of the same words on
	 * screen at once would be worse than either alone.
	 *
	 * The element carries no `crossOrigin`, which a cross-origin track would need: the media
	 * bucket sends no `Access-Control-Allow-Origin`, and setting it makes the browser refuse
	 * the video itself. A caption track that silently does not load is a far smaller loss
	 * than a player that does not play.
	 */
	subtitleUrl?: string | null;
	videoContainerClassName?: string;
	deleteFileHandler?: () => void;
	setCurrentContentInfo?: (state: IStageContentInfo | null) => void;
	isShowDeleteButton?: boolean;
	isDefaultControlsEnabled?: boolean;
}

export default function VideoContainer({
	videoUrl,
	subtitleUrl,
	deleteFileHandler,
	videoContainerClassName,
	setCurrentContentInfo,
	isShowDeleteButton = true,
	isDefaultControlsEnabled = false,
}: VideoContainerProps) {
	return (
		<Box alignItems="center" display="flex" justifyContent="center" position="relative">
			{videoUrl && (
				<>
					<video
						className={`w-auto h-[60vh] object-cover hover:cursor-pointer rounded-xl ${videoContainerClassName}`}
						controls={isDefaultControlsEnabled}
						src={videoUrl}
						onClick={() => {
							if (setCurrentContentInfo && typeof setCurrentContentInfo === "function") {
								setCurrentContentInfo({
									content: videoUrl,
									contentType: FileTypes.Video,
								});
							}
						}}
					>
						{!!subtitleUrl && (
							<track kind="subtitles" label="Deutsch" src={subtitleUrl} srcLang="de" />
						)}
					</video>
					{!isDefaultControlsEnabled && (
						<IconButton
							className="flex items-center justify-center"
							style={{
								position: "absolute",
								top: "50%",
								left: "50%",
								transform: "translate(-50%, -50%)",
								backgroundColor: "rgba(0, 0, 0, 0.5)",
								color: "white",
								fontSize: "2rem",
								width: "40px",
								height: "40px",
							}}
							onClick={(e) => {
								e.stopPropagation();
								if (setCurrentContentInfo && typeof setCurrentContentInfo === "function") {
									setCurrentContentInfo({
										content: videoUrl,
										contentType: FileTypes.Video,
									});
								}
							}}
						>
							<Icon className="-mr-1" icon={faPlay} size="sm" />
						</IconButton>
					)}
				</>
			)}
			{isShowDeleteButton && videoUrl && (
				<Box color="#D9A400" display="flex" position="absolute" right="0" top="0">
					<Box
						bgcolor="red.main"
						borderRadius={1}
						boxShadow={1}
						height={28}
						p="4px 6px"
						sx={{ cursor: "pointer" }}
						onClick={() => {
							if (deleteFileHandler && typeof deleteFileHandler === "function") {
								deleteFileHandler();
							}
						}}
					>
						<DeleteOutlineRounded />
					</Box>
				</Box>
			)}
		</Box>
	);
}
